import React from 'react'

export default function ChipsSkeleton({ count = 6, withSwatch = false }: { count?: number; withSwatch?: boolean }) {
    return (
        <div className="flex flex-wrap gap-2 pb-4">
            {Array.from({ length: count }).map((_, i) => (
                <div
                    key={i}
                    className="animate-pulse bg-muted-color rounded-full h-8 flex items-center gap-2 px-3"
                    style={{ width: `${56 + (i % 3) * 20}px` }}
                >
                    {withSwatch && <span className="w-4 h-4 rounded-full bg-black/10 shrink-0" />}
                    <span className="h-2.5 rounded-full bg-black/10 flex-1" />
                </div>
            ))}
        </div>
    );
}